// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"348f1f49","458":"a7bacb39","518":"4a1c58ea","523":"0881a00c","707":"49271d04","713":"de159078","787":"0e164631","944":"386b2be5"}[chunkId] + ".chunk.js";
};